/* eslint 'no-useless-concat' :'off',eqeqeq : 'off'  */
import * as types from '../actionTypes';
import * as url from '../../api/url';
import APIutil from '../../api/APIutils';
import { global_error_handling } from '../GlobalErrorMgmtAction';

export function GetAllCampusInvoices(a_Month, a_Year, a_CampusName){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_AllCampusInvoices+a_Month+'/'+a_Year+'/'+a_CampusName).then(response => {
            dispatch(global_error_handling(response));
            if(response != null && response != undefined)
                dispatch(actionToStoreSuccess(response,types.GET_ASU_CAMPUS_INVOICES));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetCampusBuildingInvoiceByBuildingId(a_CampusBuildingId,a_SelectedYear){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_CampusBuildingInvoiceByBuildingId+a_CampusBuildingId+'/'+a_SelectedYear).then(response => {
            dispatch(global_error_handling(response));
            if(response != null && response != undefined)
            dispatch(actionToStoreSuccess(response,types.GET_CAMPUS_BUILDING_INVOICE_BUILDINGID));
        }).catch(error => {
            throw error;
        })
    }
}

export function ASUGenerateSummaryInvoice(data){
    return function (dispatch) {
        console.log(data);
        return APIutil.postDataForPDF(url.Generate_ASU_Summary_Invoice,data).then(response => {
           // var fileName = response.headers['content-disposition'].split(";")[1].substring(10,response.headers['content-disposition'].split(";")[1].length)
           var lDate = data.invoiceDate.split(' ');
           var fileName = data.buildingId + "_" + lDate[0] + "_" + lDate[1], fileFormat = '.pdf';
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
               // window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName.replace(/"/g, ''));
               window.navigator.msSaveOrOpenBlob(new Blob([response.data]),  fileName + fileFormat);
            }
            else {
            const url = decodeURIComponent(encodeURIComponent(window.URL.createObjectURL(new Blob([response.data]))));
            const link = document.createElement('a');
            link.href = url;
           // link.setAttribute('download', fileName.replace(/"/g, ''));
            link.setAttribute('download', fileName + fileFormat);
            document.body.appendChild(link);
            link.click();
            }
        }).catch(error => { throw error; })
    } 
}

export function DownlodBuildingInvoiceExcel(a_InvoiceInput){
    return function (dispatch) {
        return APIutil.postDataForPDF(url.get_BuildingInvoiceExcel, a_InvoiceInput).then(response => {
            var lDate = a_InvoiceInput.invoiceDate.split(' ');
            var fileName = a_InvoiceInput.buildingId + "_" + lDate[0] + "_" + lDate[1] + "_ASUInvoice", fileFormat = '.xlsx';
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName + fileFormat);
            }
            else {
            const url = decodeURIComponent(encodeURIComponent(window.URL.createObjectURL(new Blob([response.data]))));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName + fileFormat);
            document.body.appendChild(link);
            link.click();
            }
        }).catch(error => { throw error; })
    }
}

export function GetCampusMonthlyCharges(a_Year,a_Campus){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_CampusMonthlyCharges+'/'+a_Year+'/'+a_Campus).then(response => {
            dispatch(global_error_handling(response));
            if(response != null && response != undefined)
                dispatch(actionToStoreSuccess(response,types.GET_CAMPUS_MONTHLYCHARGES));
        }).catch(error => { throw error; })
    }
}

export function GetCampusBillingFilters(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_AllCampusInvoicesFilter).then(response => {
            dispatch(global_error_handling(response));
            if(response != null && response != undefined)
                dispatch(actionToStoreSuccess(response,types.GET_ASU_CAMPUS_FILTERS));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetCalculationDiagram(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_BillingCalculation).then(response => {
            dispatch(global_error_handling(response));
            if(response != null && response != undefined)
                dispatch(actionToStoreSuccess(response,types.GET_BILLING_CALCULATION));
        }).catch(error => { throw error; })
    }
}

export function actionToStoreSuccess(response,actionType){
    return{
        type : actionType,
        getResponse : response,
    }
}